import {
  BidDomainQueryModelSchema,
  OrganizationDomainQueryModelSchema,
  ProjectDomainQueryModelSchema,
  TeamDomainQueryModelSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const ProjectQueryShapeSchema = ProjectDomainQueryModelSchema.required({
  bids: true,
})

export type ProjectQueryShape = ZodInfer<typeof ProjectQueryShapeSchema>

export const OrganizationQueryShapeSchema =
  OrganizationDomainQueryModelSchema.required({ partnerPrograms: true })

export type OrganizationQueryShape = ZodInfer<
  typeof OrganizationQueryShapeSchema
>

export const BidQueryShapeSchema = BidDomainQueryModelSchema.extend({
  agencyTeam: TeamDomainQueryModelSchema,
  project: ProjectDomainQueryModelSchema.required({ package: true }),
})

export type BidQueryShape = ZodInfer<typeof BidQueryShapeSchema>
